import Vue from 'vue'
import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import AuthLayout from "@/layout/dashboard/AuthLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import Login from "@/pages/Auth/login.vue";
import ParentLogin from "@/pages/Auth/parent_login.vue";
import TeacherLogin from "@/pages/Auth/teacher_login.vue";
import ParentRegister from "@/pages/Auth/parent_register.vue";
import ForgotPassword from "@/pages/Auth/ForgotPassword.vue";

// Admins
import Admins from "@/pages/Admin/Index.vue";
import AdminsCreate from "@/pages/Admin/Create.vue";
import AdminsEdit from "@/pages/Admin/Edit.vue";
import AdminsShow from "@/pages/Admin/Show.vue";

// Roles
import Roles from "@/pages/Role/Index.vue";
import RolesCreate from "@/pages/Role/Create.vue";
import RolesEdit from "@/pages/Role/Edit.vue";
import RolesShow from "@/pages/Role/Show.vue";

// Parent
import Parents from "@/pages/Parents/Index.vue";
import ParentsCreate from "@/pages/Parents/Create.vue";
import ParentsEdit from "@/pages/Parents/Edit.vue";
import ParentsShow from "@/pages/Parents/Show.vue";


// Enterprises
import Enterprises from "@/pages/Enterprise/Index.vue";
import EnterpriseEdit from "@/pages/Enterprise/Edit.vue";

import Stages from "@/pages/Stage/Index.vue";
import StagesCreate from "@/pages/Stage/Create.vue";
import StagesEdit from "@/pages/Stage/Edit.vue";

import Lessons from "@/pages/Lesson/Index.vue";
import LessonsCreate from "@/pages/Lesson/Create.vue";
import LessonsEdit from "@/pages/Lesson/Edit.vue";

import Groups from "@/pages/Group/Index.vue";
import GroupsCreate from "@/pages/Group/Create.vue";
import GroupsEdit from "@/pages/Group/Edit.vue";

import NotificationTemplates from "@/pages/NotificationTemplate/Index.vue";
import NotificationTemplatesCreate from "@/pages/NotificationTemplate/Create.vue";
import NotificationTemplatesEdit from "@/pages/NotificationTemplate/Edit.vue";

import ParentNotifications from "@/pages/ParentNotification/Index.vue";
import ParentNotificationsCreate from "@/pages/ParentNotification/Create.vue";
import ParentNotificationsEdit from "@/pages/ParentNotification/Edit.vue";
import ParentNotificationsShow from "@/pages/ParentNotification/Show.vue";
import ParentNotificationsShowing from "@/pages/ParentNotification/Showing.vue";

import ReportNotifications from "@/pages/ParentNotificationDashForAdmin/Index.vue";

import Notifications from "@/pages/ParentNotificationDash/Index.vue";
import NotificationsShow from "@/pages/ParentNotificationDash/Show.vue";
import NotificationsShowing from "@/pages/ParentNotificationDash/Showing.vue";


import Items from "@/pages/Item/Index.vue";
import ItemsCreate from "@/pages/Item/Create.vue";
import ItemsEdit from "@/pages/Item/Edit.vue";

import Budgets from "@/pages/Budget/Index.vue";
import BudgetsCreate from "@/pages/Budget/Create.vue";
import BudgetsEdit from "@/pages/Budget/Edit.vue";

import Activities from "@/pages/Activity/Index.vue";
import ActivitiesCreate from "@/pages/Activity/Create.vue";
import ActivitiesEdit from "@/pages/Activity/Edit.vue";

import Vouchers from "@/pages/Voucher/Index.vue";
import VouchersCreate from "@/pages/Voucher/Create.vue";
import VouchersEdit from "@/pages/Voucher/Edit.vue";
import VouchersFeeCreate from "@/pages/Voucher/FeeCreate.vue";
import VouchersFeeEdit from "@/pages/Voucher/FeeEdit.vue";
import VouchersFeeIndex from "@/pages/Voucher/FeeIndex.vue";


import BudgetsConfirm from "@/pages/BudgetConfirm/Index.vue";

import ActivitiesConfirm from "@/pages/ActivityConfirm/Index.vue";

import Events from "@/pages/Event/Index.vue";
import EventsCreate from "@/pages/Event/Create.vue";
import EventsEdit from "@/pages/Event/Edit.vue";

import ParentEvents from "@/pages/ParentEvent/Index.vue";
import ParentEventsShow from "@/pages/ParentEvent/Show.vue";

import Teachers from "@/pages/Teacher/Index.vue";
import TeachersCreate from "@/pages/Teacher/Create.vue";
import TeachersEdit from "@/pages/Teacher/Edit.vue";

import Interviews from "@/pages/Interview/Index.vue";
import InterviewsCreate from "@/pages/Interview/Create.vue";
import InterviewsEdit from "@/pages/Interview/Edit.vue";


import Students from "@/pages/Student/Index.vue";
import StudentsCreate from "@/pages/Student/Create.vue";
import StudentssEdit from "@/pages/Student/Edit.vue";


import MyStudents from "@/pages/ParentStudent/Index.vue";
import MyStudentssEdit from "@/pages/ParentStudent/Edit.vue";

import SaveReviews from "@/pages/SaveReviews/Index.vue";
import SaveReviewsCreate from "@/pages/SaveReviews/Create.vue";
import SaveReviewsEdit from "@/pages/SaveReviews/Edit.vue";

import SaveReviewPlans from "@/pages/SaveReviewPlans/Index.vue";
import SaveReviewPlansCreate from "@/pages/SaveReviewPlans/Create.vue";
import SaveReviewPlansEdit from "@/pages/SaveReviewPlans/Edit.vue";

import Absences from "@/pages/Absences/Index.vue";
import AbsencesCreate from "@/pages/Absences/Create.vue";
import AbsencesEdit from "@/pages/Absences/Edit.vue";

import AddDegrees from "@/pages/AddDegrees/Index.vue";
import AddDegreesCreate from "@/pages/AddDegrees/Create.vue";
import AddDegreesEdit from "@/pages/AddDegrees/Edit.vue";

import AttendDegrees from "@/pages/AttendDegrees/Index.vue";
import AttendDegreesCreate from "@/pages/AttendDegrees/Create.vue";
import AttendDegreesEdit from "@/pages/AttendDegrees/Edit.vue";

import ActiveDegrees from "@/pages/ActiveDegrees/Index.vue";
import ActiveDegreesCreate from "@/pages/ActiveDegrees/Create.vue";
import ActiveDegreesEdit from "@/pages/ActiveDegrees/Edit.vue";

import Requests from "@/pages/Requests/Index.vue";
import RequestsCreate from "@/pages/Requests/Create.vue";

import ReportsAbsence from "@/pages/Reports/Absences.vue";
import DayAbsence from "@/pages/Reports/DayAbsence.vue";
import TeacherReview from "@/pages/Reports/TeacherReview.vue";
import StudentDegree from "@/pages/Reports/StudentDegrees.vue";
import LessonAbsences from "@/pages/Reports/LessonAbsences.vue";
import StudentLessonAbsences from "@/pages/Reports/StudentLessonAbsences.vue";
import SaveReview from "@/pages/Reports/ReviewSave.vue";
import WeekDegree from "@/pages/Reports/WeekDegree.vue";
import TotalStudentDegree from "@/pages/Reports/TotalStudentDegree.vue";


// Profile
import ProfileInfo from "@/pages/Profile/index";
import Profile from "@/pages/Profile/Profile";



import store from "@/store";
import baseApi from '@/baseApi'

function isAppleDevice() {
  return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
}

function localStorageAvailable() {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

function storeData(key, value) {
  let dataToStore;

  // Check if value is an object (JSON) or a simple string
  if (typeof value == 'object' && value !== null) {
    dataToStore = JSON.stringify(value); // Convert JSON object to string
  } else {
    dataToStore = value; // If it's already a string, store it as is
  }

  if (isAppleDevice() && !localStorageAvailable()) {
    // Store the data in cookies for Apple devices
    document.cookie = `${key}=${dataToStore}; path=/`;
  } else {
    // Store the data in localStorage for other devices
    localStorage.setItem(key, dataToStore);
  }
}

function retrieveData(key) {
  let data;

  if (isAppleDevice() && !localStorageAvailable()) {
    // Retrieve data from cookies
    const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
    data = match ? match[2] : null;
  } else {
    // Retrieve data from localStorage
    data = localStorage.getItem(key);
  }

  try {
    // Try to parse the data as JSON
    return JSON.parse(data);
  } catch (e) {
    // If parsing fails, return the data as a string
    return data;
  }
}

function removeData(key) {
  if (isAppleDevice() && !localStorageAvailable()) {
    // Remove data from cookies
    document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  } else {
    // Remove data from localStorage
    localStorage.removeItem(key);
  }
}



const Middleware = () => {

  return async (to, from, next) => {
    //const roles           = store.getters.GET_AUTH_USER.role;
    store.commit('initialiseStore');
    const auth            = store.getters.SET_AUTH;
    const isRequiredAuth  = to.matched.some(r => r.meta.requiredAuth);
    // const hasRoles        = to.matched.some(r => r.meta.userRoles);
    const isHide          = to.matched.some((r) => r.meta.hideForAuth);
    
    if(isRequiredAuth && !auth){
        return next('/login');
    }
    if(isHide && auth){
      return next('/dashboard');
  }
  if(Vue.$cookies.isKey('token')){
    let auth = store.getters.SET_AUTH_USER;
    let url  = auth.role == 'admin' ? '/check-user' : (auth.role == 'teacher' ? '/teacher-check-user' : '/parent-check-user');
    const res = await baseApi().get(url).then((response)=>{
      let resp = response.data.data;
      if(response.data.code == 200){
        store.dispatch('SET_AUTH_USER', resp.user);
        store.dispatch('SET_PERMISSIONS', resp.permissions);
        let token = {
          value: resp.access_token,
          type: resp.token_type,
          expires_at: resp.expires_in
        };
        store.dispatch('SET_TOKEN', token);
        store.dispatch('SET_WEBSITE_SETTING_KEYS', resp.settings);
        store.dispatch('SET_AUTH', true);
        // storeData('token', token.value);
        // storeData("auth", JSON.stringify(resp.user));
        // storeData("settings", JSON.stringify(resp.settings));

        Vue.$cookies.set('token', token.value);
        Vue.$cookies.set('role', resp.user.role);
        Vue.$cookies.set('user', {name: resp.user.name, email: resp.user.email, role: resp.user.role});
        // Vue.$cookies.set('auth', JSON.stringify(resp.user));
        // Vue.$cookies.set('settings', JSON.stringify(resp.settings));
        
      }else{
        // removeData('token');
        // removeData("auth");
        // removeData("settings");
        Vue.$cookies.remove('token');
        Vue.$cookies.remove('role');
        Vue.$cookies.remove('user');
        // location.reload();
      }
  }).catch((response)=>{
    // removeData('token');
    // removeData("auth");
    // removeData("settings");
    Vue.$cookies.remove('token');
    Vue.$cookies.remove('role');
    Vue.$cookies.remove('user');
    // location.reload();
  });

  if(auth.role == 'parent'){
      baseApi().get('/new-notifications').then((response)=>{
          let resp = response.data.data;
          if(response.data.code == 200){
            store.dispatch('SET_NOTIFICATION_COUNT', resp.count);
            store.dispatch('SET_NOTIFICATION_DATA', resp.data);
          }
      }).catch((response)=>{
    });
  }

  }
  

    return next();
  }
}

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    meta: {
      requiredAuth: true,
      // userRoles: []
    },
    beforeEnter: Middleware(),
    children: [
      {
      path: "dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiredAuth: true,
        // userRoles: []
      },
      beforeEnter: Middleware()
    },
    
    {
      path: "/admins",
      name: "admins",
      component: Admins,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/admin/create",
      name: "admins.create",
      component: AdminsCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/admins/:id/edit",
      name: "admins.edit",
      component: AdminsEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
      {
        path: "/admins/:id/show",
        name: "admins.show",
        component: AdminsShow,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
    {
      path: "/roles",
      name: "roles",
      component: Roles,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/roles/create",
      name: "roles.create",
      component: RolesCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/roles/:id/edit",
      name: "roles.edit",
      component: RolesEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/roles/:id/show",
      name: "roles.show",
      component: RolesShow,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/enterprises/:id/edit",
      name: "enterprises.edit",
      component: EnterpriseEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/stages",
      name: "stages",
      component: Stages,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/stages/create",
      name: "stages.create",
      component: StagesCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/stages/:id/edit",
      name: "stages.edit",
      component: StagesEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/groups",
      name: "groups",
      component: Groups,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/groups/create",
      name: "groups.create",
      component: GroupsCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/groups/:id/edit",
      name: "groups.edit",
      component: GroupsEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/lessons",
      name: "lessons",
      component: Lessons,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/lessons/create",
      name: "lessons.create",
      component: LessonsCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/lessons/:id/edit",
      name: "lessons.edit",
      component: LessonsEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/teachers",
      name: "teachers",
      component: Teachers,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/teachers/create",
      name: "teachers.create",
      component: TeachersCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/teachers/:id/edit",
      name: "teachers.edit",
      component: TeachersEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/interviews",
      name: "interviews",
      component: Interviews,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/interviews/create",
      name: "interviews.create",
      component: InterviewsCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/interviews/:id/edit",
      name: "interviews.edit",
      component: InterviewsEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/events",
      name: "events",
      component: Events,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/events/create",
      name: "events.create",
      component: EventsCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/events/:id/edit",
      name: "events.edit",
      component: EventsEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/parent-events",
      name: "parent-events",
      component: ParentEvents,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/parent-events/:id/show",
      name: "parent-events.show",
      component: ParentEventsShow,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/students",
      name: "students",
      component: Students,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/students/create",
      name: "students.create",
      component: StudentsCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/students/:id/edit",
      name: "students.edit",
      component: StudentssEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/my-students",
      name: "my-students",
      component: MyStudents,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/my-students/:id/edit",
      name: "my-students.edit",
      component: MyStudentssEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/saveReviews",
      name: "saveReviews",
      component: SaveReviews,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/saveReviews/create",
      name: "saveReviews.create",
      component: SaveReviewsCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/saveReviews/:id/edit",
      name: "saveReviews.edit",
      component: SaveReviewsEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/saveReviewPlans",
      name: "saveReviewPlans",
      component: SaveReviewPlans,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/saveReviewPlans/create",
      name: "saveReviewPlans.create",
      component: SaveReviewPlansCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/saveReviewPlans/:id/edit",
      name: "saveReviewPlans.edit",
      component: SaveReviewPlansEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/absences",
      name: "absences",
      component: Absences,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/absences/create",
      name: "absences.create",
      component: AbsencesCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/absences/:id/edit",
      name: "absences.edit",
      component: AbsencesEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/reports/absence-day",
      name: "reports.absences_day",
      component: DayAbsence,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/reports/absence",
      name: "reports.absences",
      component: ReportsAbsence,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/reports/teacher-review",
      name: "reports.review",
      component: TeacherReview,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/reports/student-degrees",
      name: "reports.studentDegrees",
      component: StudentDegree,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },  
    {
      path: "/reports/lesson-absences",
      name: "reports.lessonAbsences",
      component: LessonAbsences,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },  
    {
      path: "/reports/student-lesson-absences",
      name: "reports.studentLessonAbsences",
      component: StudentLessonAbsences,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },  
    {
      path: "/reports/save-review",
      name: "reports.saveReview",
      component: SaveReview,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },  
    {
      path: "/reports/week-degree",
      name: "reports.weekDegree",
      component: WeekDegree,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },  
    {
      path: "/reports/total-student-degree",
      name: "reports.totalStudentDegree",
      component: TotalStudentDegree,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },  
    {
      path: "/addDegrees",
      name: "addDegrees",
      component: AddDegrees,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/addDegrees/create",
      name: "addDegrees.create",
      component: AddDegreesCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/addDegrees/:id/edit",
      name: "addDegrees.edit",
      component: AddDegreesEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/attendDegrees",
      name: "attendDegrees",
      component: AttendDegrees,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/attendDegrees/create",
      name: "attendDegrees.create",
      component: AttendDegreesCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/attendDegrees/:id/edit",
      name: "attendDegrees.edit",
      component: AttendDegreesEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/activeDegrees",
      name: "activeDegrees",
      component: ActiveDegrees,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/activeDegrees/create",
      name: "activeDegrees.create",
      component: ActiveDegreesCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/activeDegrees/:id/edit",
      name: "activeDegrees.edit",
      component: ActiveDegreesEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/parents",
      name: "parents",
      component: Parents,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/parents/create",
      name: "parents.create",
      component: ParentsCreate,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    {
      path: "/parents/:id/edit",
      name: "parents.edit",
      component: ParentsEdit,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
      {
        path: "/parents/:id/show",
        name: "parents.show",
        component: ParentsShow,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/parents",
        name: "parents",
        component: Parents,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/parents",
        name: "parents",
        component: Parents,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/items",
        name: "items",
        component: Items,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/items/create",
        name: "items.create",
        component: ItemsCreate,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/items/:id/edit",
        name: "items.edit",
        component: ItemsEdit,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/budgets",
        name: "budgets",
        component: Budgets,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/budgets/create",
        name: "budgets.create",
        component: BudgetsCreate,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/budgets/:id/edit",
        name: "budgets.edit",
        component: BudgetsEdit,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/notificationTemplates",
        name: "notificationTemplates",
        component: NotificationTemplates,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/notificationTemplates/create",
        name: "notificationTemplates.create",
        component: NotificationTemplatesCreate,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/notificationTemplates/:id/edit",
        name: "notificationTemplates.edit",
        component: NotificationTemplatesEdit,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "report/notifications",
        name: "report.notifications",
        component: ReportNotifications,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/notifications",
        name: "notifications",
        component: Notifications,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/notifications/:id/show",
        name: "notifications.show",
        component: NotificationsShow,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/show-notifications",
        name: "notifications.showing",
        component: NotificationsShowing,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/parentNotifications",
        name: "parentNotifications",
        component: ParentNotifications,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/parentNotifications/create",
        name: "parentNotifications.create",
        component: ParentNotificationsCreate,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/parentNotifications/:id/edit",
        name: "parentNotifications.edit",
        component: ParentNotificationsEdit,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/parentNotifications/:id/show",
        name: "parentNotifications.show",
        component: ParentNotificationsShow,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/show-parentNotifications",
        name: "parentNotifications.showing",
        component: ParentNotificationsShowing,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/budgets-confirm",
        name: "budgetsConfirm",
        component: BudgetsConfirm,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/activities-confirm",
        name: "activitiesConfirm",
        component: ActivitiesConfirm,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/requests",
        name: "requests",
        component: Requests,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/activities",
        name: "activities",
        component: Activities,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/activities/create",
        name: "activities.create",
        component: ActivitiesCreate,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/activities/:id/edit",
        name: "activities.edit",
        component: ActivitiesEdit,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/vouchers",
        name: "vouchers",
        component: Vouchers,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/vouchers/create",
        name: "vouchers.create",
        component: VouchersCreate,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/vouchers/:id/edit",
        name: "vouchers.edit",
        component: VouchersEdit,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/student-fees",
        name: "students.fees",
        component: VouchersFeeCreate,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/student-fees/:id/edit",
        name: "students.fees.edit",
        component: VouchersFeeEdit,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/student-fees-all",
        name: "students.fees.index",
        component: VouchersFeeIndex,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/requests/create",
        name: "requests.create",
        component: RequestsCreate,
        meta: {
          requiredAuth: true,
        },
        beforeEnter: Middleware()
      },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        requiredAuth: true,
      },
      beforeEnter: Middleware()
    },
    ]
  },
  {
    path: "/login",
    component: AuthLayout,
    redirect: "/login",
    children: [
      {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
          hideForAuth: true,
          requiredAuth: false,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/parent-login",
        name: "parent-login",
        component: ParentLogin,
        meta: {
          hideForAuth: true,
          requiredAuth: false,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/parent-register",
        name: "parent-register",
        component: ParentRegister,
        meta: {
          hideForAuth: true,
          requiredAuth: false,
        },
        beforeEnter: Middleware()
      },
      {
        path: "/teacher-login",
        name: "teacher-login",
        component: TeacherLogin,
        meta: {
          hideForAuth: true,
          requiredAuth: false,
        },
        beforeEnter: Middleware()
      },
    ]
  },
  {
    path: "/forgot-password",
    component: AuthLayout,
    redirect: "/forget-password",
    children: [
      {
        path: "/forgot-password",
        name: "forgot-password",
        component: ForgotPassword,
        meta: {
          hideForAuth: true,
          requiredAuth: false,
        },
        beforeEnter: Middleware()
      }
    ]
  },
  { path: "*", component: NotFound }
];

export default routes;
